import React from 'react';

const KkpPlanningSemaineSelect = ({
  value,
  onChange,
  options = [],
  allowEmpty = true,
  emptyLabel = 'Toutes',
  required = false,
  className = 'form-select',
  id,
}) => {
  const hasCurrentValue = value
    && !options.some((option) => option.value === value);

  return (
    <select
      id={id}
      className={className}
      value={value ?? ''}
      onChange={onChange}
      required={required}
    >
      {allowEmpty && (
        <option value="">{emptyLabel}</option>
      )}
      {options.map((option) => (
        <option key={option.date || option.value} value={option.value}>
          {option.label}
        </option>
      ))}
      {hasCurrentValue && (
        <option value={value}>{value}</option>
      )}
    </select>
  );
};

export default KkpPlanningSemaineSelect;
